import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RegistrationService } from '../../services/registration.service';
import { ValidateConfirmPassword } from '../../validators/confirmPassword.validator';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})
export class ChangepasswordComponent implements OnInit {

  show: boolean = false;
  changePasswordForm: FormGroup;
  dLabel: string = "Get OTP";
  userDetails: any = [];
  divShow: boolean;
  otpPasswordForm: FormGroup;
  verifyOtp: any;
  // buttonDisable: boolean = false;

  constructor(private spinner: NgxSpinnerService, private registrationService: RegistrationService, private router: Router) { }

  ngOnInit() {

    this.divShow = true;
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    // console.log(this.userDetails);

		this.changePasswordForm = new FormGroup({
			oldpassword: new FormControl('', Validators.required),
			newpassword: new FormControl('', Validators.required),
    });


    this.otpPasswordForm = new FormGroup({
			otpfield: new FormControl('', Validators.required),
    });

    // if(this.otpPasswordForm.value.get('otpfield')===''){
    //    this.buttonDisable = false;
    // }else{
    //   this.buttonDisable = true;
    // }


  } //ngOninit close bracket

  password() {
		this.show = !this.show;
	}

  onSubmit(){
    if (this.changePasswordForm.valid) {
      this.spinner.show();
      // console.log(this.userDetails.authToken);
      // this.dLabel = "Generate OTP...";
      const data = this.changePasswordForm.value;
      localStorage.setItem('changePassData', data);
      this.registrationService.getchangepasswordotp(localStorage.getItem('authToken'),data.oldpassword).then(res => {
        this.spinner.hide();
        // console.log(res);
        if(res.status === 'success'){
            this.divShow = false;
            // alert("success");
            this.verifyOtp = res.otpfield;
            this.spinner.hide();
        }else{
          alert(res.msg);
          this.spinner.hide();
          this.divShow = true;
          this.router.navigateByUrl('candidate/changepass');
        }
      },error=>{
        // this.spinner.hide();
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });

      // this.spinner.hide();
      }
      else
      {
        console.log('Form Not Submitted!');
        // console.log(this.changePasswordForm.value);
        Object.keys(this.changePasswordForm.controls).forEach(control => {
          this.changePasswordForm.controls[control].markAsDirty();
        });
      this.spinner.hide();
      }

 }


  newPassChk(){
    if(this.changePasswordForm.get('oldpassword').value === this.changePasswordForm.get('newpassword').value && this.changePasswordForm.get('newpassword').value.length>0) {
      alert('New Password cant be same as Old password');
      // console.log(this.changePasswordForm.get('oldpassword').value);
      this.changePasswordForm.controls.newpassword.setValue(null);
    }
  }


  onOtpSubmit(){
    if (this.otpPasswordForm.valid) {
      this.spinner.show();
      // console.log(this.otpPasswordForm.value.otpfield,this.verifyOtp);
      const newPass = this.changePasswordForm.value.newpassword;
        if(this.otpPasswordForm.value.otpfield === this.verifyOtp){

        this.registrationService.changepasswordbyotp(localStorage.getItem('authToken'),newPass).then(res => {
          this.spinner.hide();
          // console.log(res);
          if(res.status === 'success'){
              this.verifyOtp = 0;
              alert("password changed successfully");
              this.router.navigateByUrl('candidate/dashboard');
          }else{
            alert(res.msg);
            this.otpPasswordForm.reset();
            this.changePasswordForm.reset();
            this.verifyOtp = 0;
            this.divShow = true;
            this.router.navigateByUrl('candidate/changepass');
          }
        },error=>{
          this.verifyOtp = 0;
          alert('Something went wrong. Please try again')
          this.spinner.hide();
        });
      }else{
        this.spinner.hide();
        alert('OTP Mismatch. Please try again')
        this.verifyOtp = 0;
        this.divShow = true;
        this.otpPasswordForm.reset();
        this.changePasswordForm.reset();
        this.router.navigateByUrl('candidate/changepass');
      }
    }else{
        this.spinner.hide();
        console.log('Form Not Submitted!');
        // console.log(this.otpPasswordForm.value);
        Object.keys(this.otpPasswordForm.controls).forEach(control => {
          this.otpPasswordForm.controls[control].markAsDirty();
        });
      this.spinner.hide();
      }

 }





} //export class close bracket



// WEBPACK FOOTER //
// ./src/app/candidate/changepassword/changepassword.component.ts